import React from 'react';

import {AsyncPriceCourseCardContext} from '@udemy/browse-course';
import {FunnelLogContextProvider} from '@udemy/funnel-tracking';
import {ExperimentationProvider} from '@udemy/react-experimentation-provider';
import {
    OnePaneLayoutContainer,
    OnePaneLayoutFullWidthSection,
} from '@udemy/react-layout-components';

import {BlackFridayCyberMondaySalesPageFeatureProps} from '.';
import styles from './black-friday-cyber-monday-sales.module.less';
import {BfcmHero} from './components/bfcm-hero/bfcm-hero.react-component';
import {CertPrepSection} from './components/certification-preparation-section/certification-preparation.react-component';
import {ExploreMoreSection} from './components/explore-more-section/explore-more-section.react-component';
import {HottestTopicSection} from './components/hottest-topic-section/hottest-topic-section.react-component';

export const BlackFridayLandingPage: React.FC<BlackFridayCyberMondaySalesPageFeatureProps> = (
    props,
) => {
    const {hottestTopicsList, topicsList, academies, certificationAggregatorData} = props;

    const [mainTopic, ...otherTopics] = hottestTopicsList;

    /**
     * Adding this ExperimentationProvider as there are some experiments
     * running from the components we are using for this page.
     */
    const EXPERIMENTATION_FEATURES = [
        'personal_plan_course_enrollment',
        'fbt_force_go_to_cart',
        'cart_loginsignup_redirect_to_checkout',
        'value_planstarter_plan',
    ];

    return (
        <ExperimentationProvider features={EXPERIMENTATION_FEATURES}>
            <FunnelLogContextProvider pageType="personalized_home">
                <AsyncPriceCourseCardContext.Provider
                    value={{
                        hideCourseDescription: true,
                    }}
                >
                    <OnePaneLayoutContainer
                        className={styles['black-friday-cyber-monday-sales-container']}
                    >
                        <OnePaneLayoutFullWidthSection className={styles['section']}>
                            <BfcmHero topicsList={topicsList} />
                        </OnePaneLayoutFullWidthSection>
                        {mainTopic && (
                            <OnePaneLayoutFullWidthSection className={styles['section']}>
                                <HottestTopicSection section={mainTopic} sectionNumber={1} />
                            </OnePaneLayoutFullWidthSection>
                        )}
                        <OnePaneLayoutFullWidthSection className={styles['section']}>
                            <CertPrepSection aggregatorsData={certificationAggregatorData} />
                        </OnePaneLayoutFullWidthSection>
                        {otherTopics.map((otherTopic, index) => (
                            <OnePaneLayoutFullWidthSection
                                className={styles['section']}
                                key={otherTopic.topic.topic.id}
                            >
                                <HottestTopicSection
                                    section={otherTopic}
                                    sectionNumber={index + 3}
                                />
                            </OnePaneLayoutFullWidthSection>
                        ))}
                        <OnePaneLayoutFullWidthSection
                            className={`${styles['fill-background']} ${styles['section']}`}
                        >
                            <ExploreMoreSection academies={academies} />
                        </OnePaneLayoutFullWidthSection>
                    </OnePaneLayoutContainer>
                </AsyncPriceCourseCardContext.Provider>
            </FunnelLogContextProvider>
        </ExperimentationProvider>
    );
};
